import React from "react";
import InputComponent from "../../InputComponent";
import PhoneNumberInput from "../../PhoneNumberInput";
import InputComponentReadOnly from "../../InputComponentReadOnly";
import InputComponentV2 from "../../InputComponentV2";
import DatePickerComponentV2 from "../../DatePickerComponentV2";
import DropDownComponentV2 from "../../DropDownComponentV2";
import DropDownComponentSortedV2 from "../../DropDownComponentSortedV2";
import DatePickerComponentV2Mobile from "../../DatePickerComponentV2Mobile";
import TextFieldComponentV2Mobile from "../../TextFieldComponentV2Mobile";
import InputComponentV2Mobile from "../../InputComponentV2Mobile";

function GeneralInformationV2PersonalSection(props) {
  const {
    translate,
    firstName,
    handleFirstNameChange,
    lastName,
    handleLastNameChange,
    nickname,
    handleNicknameChange,
    personalEmail,
    handlePersonalEmailChange,
    phoneNumber,
    handlePhoneNumberChange,
    dob,
    handleDobChange,
    age,
    maritalStatus,
    handleMaritalStatusChange,
    livingWith,
    handleLivingWithChange,
    gender,
    handleGenderChange,
    genderOther,
    handleGenderOther,
    sexualOrientation,
    handleSexualOrientationChange,
    sexualOrientationOther,
    handleSexualOrientationOther,
    currentAddress,
    handleCurrentAddressChange,
    city,
    handleCityChange,
    province,
    handleProvinceChange,
    country,
    handleCountryChange,
    nationality,
    handleNationalityChange,
    clientSource,
    handleClientSourceChange,
    passportNumber,
    handlePassportNumberChange,
    visaExpirationDate,
    handleVisaExpirationDateChange,
  } = props;

  return (
    <div style={{ padding: "0px", width: "100%" }}>
      <div style={{ width: "100%", paddingLeft: "0px", paddingRight: "10px", paddingBottom: "30px", display: "flex", flexDirection: "column", flexWrap: "wrap", gap: "20px" }}>
        <div style={{ borderTop: "1px solid #cccccc", paddingTop: "20px", marginTop: "20px", paddingLeft: "10px" }}>
          <span id="personal-information" style={{ fontSize: "14px", fontWeight: "600" }}>{translate("PersonalInformation")}</span>
        </div>
        <div style={{ width: "100%", paddingLeft: "10px", paddingRight: "10px", paddingBottom: "10px", display: "flex", gap: "20px" }}>
          <InputComponentV2 title={translate("FirstName")} width="100%" value={firstName} onChange={handleFirstNameChange} />
          <InputComponentV2 title={translate("LastName")} width="100%" value={lastName} onChange={handleLastNameChange} />
        </div>
        <div style={{ width: "100%", paddingLeft: "10px", paddingBottom: "10px", display: "flex" }}>
          <InputComponentV2 title={translate("Nickname")} width="95%" value={nickname} onChange={handleNicknameChange} />
          <InputComponentV2 title={translate("Email")} width="95%" value={personalEmail} onChange={handlePersonalEmailChange} />
        </div>
        <div style={{ width: "100%", paddingLeft: "10px", paddingBottom: "10px", display: "flex", justifyContent: "space-between" }}>
          <PhoneNumberInput title={translate("PhoneNumber")} value={phoneNumber} onChange={handlePhoneNumberChange} width="95%" />
          <DatePickerComponentV2Mobile title={translate("Birthday")} width="95%" height="30px" value={dob} onChange={handleDobChange} />
        </div>
        <div style={{ width: "100%", paddingLeft: "10px", paddingBottom: "10px", display: "flex", justifyContent: "space-between" }}>
          <InputComponentReadOnly title={translate("AgeNonEditable")} width="95%" value={age} height="40px" />
        </div>
        <div style={{ width: "100%", paddingLeft: "10px", paddingBottom: "10px", display: "flex", justifyContent: "space-between" }}>
          <DropDownComponentV2 api="maritalStatus" title={translate("MaritalStatus")} value={maritalStatus} onChange={handleMaritalStatusChange} width="100%" />
          <DropDownComponentSortedV2 api="relationship" title={translate("LivingWith")} value={livingWith} onChange={handleLivingWithChange} width="100%" />
        </div>
        <div style={{ width: "100%", paddingLeft: "10px", paddingBottom: "10px", display: "flex", justifyContent: "space-between" }}>
          <DropDownComponentV2 api="gender" title={translate("Gender")} value={gender} onChange={handleGenderChange} width="100%" />
          {gender === "Other" ? <InputComponentV2 title={translate("IfOtherGenderDescribe")} width="100%" value={genderOther} onChange={handleGenderOther} /> : ""}
          <DropDownComponentV2 api="sexualOrientation" title={translate("SexualOrientation")} value={sexualOrientation} onChange={handleSexualOrientationChange} width="100%" />
          {sexualOrientation === "other" ? <InputComponent title={translate("IfOtherDescribe")} width="100%" value={sexualOrientationOther} onChange={handleSexualOrientationOther} /> : ""}
        </div>
        <div style={{ width: "100%", display: "flex", flexDirection: "row", flexWrap: "wrap", gap: "20px", paddingBottom: "10px", paddingLeft: "10px" }}>
          <TextFieldComponentV2Mobile title={translate("PhysicalAddressOfResidence")} value={currentAddress} onChange={handleCurrentAddressChange} width="100%" />
        </div>
        <div style={{ width: "100%", paddingLeft: "10px", paddingBottom: "10px", display: "flex", justifyContent: "space-between" }}>
          <InputComponentV2Mobile title={translate("City")} width="90%" value={city} onChange={handleCityChange} />
          <InputComponentV2Mobile title={translate("ProvinceState")} width="90%" value={province} onChange={handleProvinceChange} />
        </div>
        <div style={{ width: "100%", paddingLeft: "10px", paddingBottom: "10px", display: "flex", justifyContent: "space-between" }}>
          <DropDownComponentV2 api="countries" title={translate("Country")} value={country} onChange={handleCountryChange} width="95%" />
          <DropDownComponentV2 api="nationalities" title={translate("Nationality")} value={nationality} onChange={handleNationalityChange} width="95%" />
        </div>
        <div style={{ width: "100%", paddingLeft: "10px", paddingBottom: "10px", display: "flex", justifyContent: "space-between", flexWrap: "wrap" }}>
          <DropDownComponentSortedV2 api="clientSource" title={translate("ClientSource")} value={clientSource} onChange={handleClientSourceChange} width="95%" />
          <div style={{ marginTop: "10px" }}>
            <InputComponentV2 title={translate("PassportNumber")} value={passportNumber} onChange={handlePassportNumberChange} width="95%" />
          </div>
          <DatePickerComponentV2 title={translate("VisaExpirationDate")} width="250px" value={visaExpirationDate} onChange={handleVisaExpirationDateChange} />
        </div>
      </div>
    </div>
  );
}

export default GeneralInformationV2PersonalSection;
